import { render, staticRenderFns } from "./SpecsContainer.vue?vue&type=template&id=5105d773&"
import script from "./SpecsContainer.vue?vue&type=script&lang=js&"
export * from "./SpecsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports